import { IsBoolean, IsOptional, IsString } from 'class-validator';

export class UpdateBasicInformationDto {
  @IsOptional()
  @IsBoolean()
  isLegal?: boolean;

  @IsOptional()
  @IsString()
  email?: string;
}
